// extracted by mini-css-extract-plugin
export default {"blockPadding":"usePadding_blockPadding__Rb7Yq","blockPaddingCompact":"usePadding_blockPaddingCompact__SvMND"};